import { TrawlDelivery } from "./trawl-delivery.model";
import { TrawlSet } from "./trawl-set.model";
import { DeliveryStatus } from "./trip.model";

/**
 * Trawl Trip class, contains 
 */
export class TrawlTrip {

  status: DeliveryStatus = DeliveryStatus.New;

  //List of associated Fishing Events/Sets
  sets: TrawlSet[] = [];

  trawlDelivery: TrawlDelivery = new TrawlDelivery();

  constructor() { }


  setValues(anon: any) {
    //Assign all values of anon to this object
    this.sets = (anon.sets as any[]).map(s => TrawlSet.transformAnonymous(s));
    this.trawlDelivery = TrawlDelivery.transformAnonymous(anon.trawlDelivery);
  }

}
